// extracted by mini-css-extract-plugin
export var columnItem = "_5g-3";
export var columnItemDraggable = "_5g-5";
export var dragHandle = "_5g-0";
export var dragHandleHovered = "_5g-1";
export var dropdown = "_5g-6";
export var dropdownContent = "_5g-8";
export var dropdownInner = "_5g-7";
export var filterDropdownHeader = "_5g-9";
export var icon = "_5g-2";
export var moveToTopButton = "_5g-4";
export var sectionDivider = "_5g-a";